import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var VestPatches = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 448 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M437.252 239.877 384 160V32a32 32 0 0 0-32-32h-32a23.982 23.982 0 0 0-13.312 4.031l-25 16.672a103.794 103.794 0 0 1-115.376 0l-25-16.672A23.982 23.982 0 0 0 128 0H96a32 32 0 0 0-32 32v128l-53.252 79.877A64 64 0 0 0 0 275.377V480a32 32 0 0 0 32 32h160V288a31.987 31.987 0 0 1 1.643-10.119l13.492-40.481-56.947-170.839A151.579 151.579 0 0 0 224 86.234a151.565 151.565 0 0 0 73.811-19.668L224 288v224h192a32 32 0 0 0 32-32V275.377a64 64 0 0 0-10.748-35.5zM63.5 272.484a12.01 12.01 0 0 1 17-16.968l15.5 15.5 15.5-15.5a12.01 12.01 0 0 1 17 16.968L112.984 288l15.516 15.516a12.01 12.01 0 0 1-17 16.968l-15.5-15.5-15.5 15.5a12.01 12.01 0 0 1-17-16.968L79.016 288zM96 456a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm263.227-120.215L310.7 336a6.671 6.671 0 0 1-6.7-6.7l.215-48.574A24.987 24.987 0 0 1 331.43 256.1c12.789 1.162 22.129 12.619 22.056 25.419l-.037 5.057 5.051-.037c12.826-.035 24.236 9.275 25.4 22.076a24.948 24.948 0 0 1-24.673 27.17z"
  }));
});
VestPatches.displayName = 'VestPatches';
export var VestPatchesDimensions = {
  height: 512,
  width: 448
};